async function manageCookieConsent() {
    if (CONFIG.cookieConsent !== false) {
        const { cookieInfoAlert } = await import(/* webpackMode: "lazy" */ './cookieconsent/index.js');

        cookieInfoAlert();
    }
}

export { manageCookieConsent };
